export default __webpack_public_path__ + "static/media/aglc_receiptv2_example_2.430c54e2.png";